export enum GoogleAnalyticsReportFrequencyEnum {
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    MONTHLY = 'MONTHLY'
}
